<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <h6 class="block__title">Content block</h6>
      <div style="display: flex; gap: 16px">
        <a-button
          type="primary"
          style="display: flex; align-items: center"
          @click="setCategoryModalVisible(true)"
        >
          <a-icon type="plus" size="large" style="height: 14px; width: 14px" />
          Category
        </a-button>
        <a-button
          type="primary"
          style="display: flex; align-items: center"
          @click="setWidgetModalVisible(true)"
        >
          <a-icon type="plus" size="large" style="height: 14px; width: 14px" />
          Widget
        </a-button>
      </div>
    </div>
    <div class="list">
      <ContentNestedList
        v-if="currentBlocksList"
        :list="currentBlocksList"
        :selectedLanguage="selectedLanguage"
        @editCategory="handleEditCategory"
        @editWidget="handleEditWidget"
        @deleteWidget="onWidgetDelete"
        @openMatchesModal="handleOpenMatchesModal"
        @toggleCategoryTitle="handleToggleCategoriesTitle"
      />
    </div>

    <CategoryModal
      v-if="isCategoryModalVisible"
      v-model="isCategoryModalVisible"
      :data="selectedCategoryData"
      :initLang="selectedLanguage"
      @close="closeCategoryModal"
      @submit="handleCategorySubmit"
      @delete="handleCategoryDelete"
    />

    <WidgetModal
      v-if="isWidgetModalVisible"
      v-model="isWidgetModalVisible"
      :data="selectedWidgetData"
      :initLang="selectedLanguage"
      @close="closeWidgetModal"
      @submit="handleWidgetSubmit"
      @delete="handleWidgetDelete"
    />

    <EventsModal
      v-if="isEventsModalVisible"
      v-model="isEventsModalVisible"
      :selectedItems="currentBlockEvents"
      @submit="handleEventsModalSubmit"
      @close="handleCloseMatchesModal"
    />
  </div>
</template>
<script>
import CategoryModal from '@/views/apps/custom-pages/constructor/content/modals/categoryModal.vue'
import WidgetModal from '@/views/apps/custom-pages/constructor/content/modals/widgetModal.vue'
import EventsModal from '@/views/apps/custom-pages/constructor/content/modals/eventsModal.vue'

import ContentNestedList from '@/views/apps/custom-pages/components/ContentNestedList.vue'

import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  components: {
    CategoryModal,
    WidgetModal,
    EventsModal,
    ContentNestedList,
  },
  data() {
    return {
      matchSelectionCategoryId: null,
    }
  },
  computed: {
    ...mapGetters(['showAllCategoriesTitle']),
    ...mapGetters('content', [
      'selectedLanguage',
      'blocks',
      'isCategoryModalVisible',
      'isWidgetModalVisible',
      'isEventsModalVisible',
      'selectedCategoryData',
      'selectedWidgetData',
    ]),
    currentBlocksList() {
      return this.blocks?.[this.selectedLanguage]
    },
    currentBlockEvents() {
      if (!this.matchSelectionCategoryId) {
        return []
      }

      function dfs(list, acc) {
        for (const item of list) {
          if (item.type === 'match') {
            acc.push(item)
          }

          if (item.children && item.children.length > 0) {
            dfs(item.children, acc)
          }
        }
      }

      const foundBlock = this.currentBlocksList.find(
        (block) => block.id === this.matchSelectionCategoryId,
      )

      if (foundBlock && foundBlock.children?.length) {
        const matches = []

        dfs(foundBlock.children, matches)

        return matches
      }

      return null
    },
  },
  methods: {
    ...mapMutations(['SET_SHOW_ALL_CATEGORIES_TITLE']),
    ...mapMutations('content', [
      'SET_CATEGORY_MODAL_VISIBLE',
      'SET_WIDGET_MODAL_VISIBLE',
      'SET_EVENTS_MODAL_VISIBLE',
    ]),
    ...mapActions('content', [
      'onWidgetSubmit',
      'onWidgetDelete',
      'onEditCategory',
      'onEditWidget',
      'onAddEvents',
      'closeCategoryModal',
      'closeWidgetModal',
    ]),
    setCategoryModalVisible(visible) {
      this.SET_CATEGORY_MODAL_VISIBLE(visible)
    },
    setWidgetModalVisible(visible) {
      this.SET_WIDGET_MODAL_VISIBLE(visible)
    },
    setEventsModalVisible(visible) {
      this.SET_EVENTS_MODAL_VISIBLE(visible)
    },
    handleCategorySubmit(data, id) {
      this.$store.dispatch('content/onCategorySubmit', { data, id })
    },
    handleCategoryDelete(id) {
      this.$store.dispatch('content/onCategoryDelete', id)
    },
    handleWidgetSubmit(data, id) {
      this.$store.dispatch('content/onWidgetSubmit', { data, id })
    },
    handleWidgetDelete(id) {
      this.$store.dispatch('content/onWidgetDelete', id)
    },
    handleEditCategory(id) {
      this.$store.dispatch('content/onEditCategory', id)
    },
    handleEditWidget(id) {
      this.$store.dispatch('content/onEditWidget', id)
    },
    handleEventsModalSubmit(data) {
      const selectedCategory = this.matchSelectionCategoryId

      this.onAddEvents({ data, id: selectedCategory })

      this.handleCloseMatchesModal()
    },
    handleOpenMatchesModal(categoryId) {
      this.matchSelectionCategoryId = categoryId
      this.setEventsModalVisible(true)
    },
    handleCloseMatchesModal() {
      this.setEventsModalVisible(false)
      this.matchSelectionCategoryId = null
    },
    handleToggleCategoriesTitle() {
      this.SET_SHOW_ALL_CATEGORIES_TITLE(!this.showAllCategoriesTitle)
    },
  },
}
</script>
<style lang="scss" scoped>
.list {
  margin-top: 24px;
}

.category__header {
  display: flex;
  align-items: center;
  gap: 12px;
}

.category__header-title {
  font-size: 20px;
  line-height: 28px;
  font-weight: 600;
  color: #000;
}

.category__header-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  line-height: 1;
  width: 20px;
  height: 20px;
  padding: 0;
  border: none;
  color: #8c8c8c;

  &:hover,
  &:focus {
    color: #8c8c8c;
  }
}
</style>
